import React from 'react'
import { DownloadIconProps } from './DownloadIconTypes';

const DownloadIcon = (props: DownloadIconProps) => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_VIEW;

  const { selectedDownloadDocument } = props;


  // useEffect(() => {

  // }, [props])
  const downloadDocument = () => {

    if (selectedDownloadDocument.signed?.documentPath) {
      const baseUrl = imageBaseUrl || '';
      const url: string = baseUrl + selectedDownloadDocument.signed.documentPath;


      window.location.href = url;
    }
  }
  const handelClose = () => {

    window.close();
  }
  return (
    <>
      <div className='absolute right-5'>
        <p className='flex items-center justify-center download-icon'>
          <span className="material-symbols-outlined cursor-pointer" onClick={() => { handelClose() }} >
            close
          </span></p>
        {selectedDownloadDocument?.signed && <p className='flex items-center justify-center download-icon' onClick={() => { downloadDocument() }} >
          <span className="material-symbols-outlined cursor-pointer" >
            file_download
          </span></p>}
      </div>

    </>

  )
}

export default DownloadIcon
